export default {
  subMenu: {
    Dashboard: [
      {
        key: 'Overview',
        url: '/dashboard/overview',
      },
      {
        key: 'Sales History',
        url: '/dashboard/sales-by-history',
      },
      {
        key: 'Sales By Location',
        url: '/dashboard/sales-by-location',
      },
      {
        key: 'Top States',
        url: '/dashboard/top-states',
      },
      {
        key: 'Revenue',
        url: '#',
      },
      {
        key: 'Sales',
        url: '#',
      },
      {
        key: 'Customers',
        url: '#',
      },
      {
        key: 'Marketing',
        url: '#',
      },
      {
        key: 'Finance',
        url: '#',
      },
      {
        key: 'Products',
        url: '#',
      },
    ],
    Ecommerce: [
      {
        key: 'Inventory',
        url: '#',
        microMenu: [
          {
            key: 'Products',
            url: '/ecommerce/inventory/products',
          },
          {
            key: 'Categories',
            url: '/ecommerce/inventory/categories',
          },
          {
            key: 'Sub Categories',
            url: '/ecommerce/inventory/sub-categories',
          },
          {
            key: 'Micro Categories',
            url: '/ecommerce/inventory/micro-categories',
          },
          {
            key: 'Attributes Group',
            url: '/ecommerce/inventory/attributes-groups',
          },
        ],
      },
      {
        key: 'Loyalty',
        url: '#',
        microMenu: [
          {
            key: 'Loyalty Level',
            url: '/ecommerce/loyalty/levels',
          },
          {
            key: 'Loyalty Items',
            url: '/ecommerce/loyalty/levels/items',
          },
          {
            key: 'Loyalty Customers',
            url: '/ecommerce/loyalty/levels/customers',
          },
        ],
      },
      {
        key: 'Coupon',
        url: '#',
        microMenu: [
          {
            key: 'Coupons',
            url: '/ecommerce/coupons',
          },
          {
            key: 'Coupon Items',
            url: '/ecommerce/coupons/items',
          },
        ],
      },
      {
        key: 'Supply',
        url: '#',
        microMenu: [
          // {
          //   key: 'Supplier Invoices',
          //   url: '#',
          // },
          {
            key: 'Supplied Goods',
            url: '/ecommerce/supply/goods',
          },
          {
            key: 'Suppliers',
            url: '/ecommerce/supply/suppliers',
          },
          {
            key: 'Suppliers Group',
            url: '/ecommerce/supply/suppliers-groups',
          },
          {
            key: 'Shippers',
            url: '/ecommerce/supply/shippers',
          },
        ],
      },
      {
        key: 'Outlets',
        url: '/ecommerce/outlets',
      },
      {
        key: 'Customers',
        url: '/ecommerce/customers',
      },
      {
        key: 'Orders',
        url: '/ecommerce/orders',
      },
      {
        key: 'Payments',
        url: '/ecommerce/payments',
      },
      {
        key: 'Staff Members',
        url: '#',
      },
      {
        key: 'Security',
        url: '/ecommerce/security',
        microMenu: [
          {
            key: 'Permission',
            url: '/ecommerce/security/permission',
          },
          {
            key: 'Role',
            url: '/ecommerce/security/roles',
          },
        ],
      },
      {
        key: 'Settings',
        url: '/ecommerce/settings',
        microMenu: [
          {
            key: 'Payment Methods',
            url: '/ecommerce/settings/payment-methods',
          },
          {
            key: 'Delivery Methods',
            url: '/ecommerce/settings/delivery-methods',
          },
          {
            key: 'Countries',
            url: '/ecommerce/settings/countries',
          },
          {
            key: 'Default Settings',
            url: '/ecommerce/settings/statuses',
          },
          {
            key: 'Configurations',
            url: '/ecommerce/settings/configs',
          },
          {
            key: 'Profile',
            url: '/ecommerce/settings/profile',
          },
          {
            key: 'Images',
            url: '/ecommerce/settings/images-uploads',
          },
        ],
      },
    ],
    Customer: [
      {
        key: 'Merchant Files',
        url: '/customer/merchant-files-upload',
      },
      {
        key: 'Customers 360',
        url: '/customer/customer-360',
      },
      {
        key: 'Customers Charts',
        url: '/customer/customer-charts',
      },
    ],
    Geospatial: [
      {
        key: 'Sales Geospatial',
        url: '/geospatial/sale-analysis',
      },
      {
        key: 'Customer Geospatial',
        url: '#',
      },
    ],
    Recommendation: [
      {
        key: 'Recommendation KPI',
        url: '/recommendation/kpi',
      },
      {
        key: 'Events Triggers',
        url: '/recommendation/triggers',
      },
    ],
    Prediction: [
      {
        key: 'Prediction',
        url: '#',
      },
    ],
  },
  doNotShowMenu: ['csv-upload'],
};
